export default
    {
        // 亚运宝贝招聘提交
        async recruitmentActive(params) {
            let actiontype = 'recruitmentActive';
            return await this.fetch(actiontype, params);
        },
        // 获取亚运宝贝投递记录
        async selectRecruitmentActive(params) {
            let actiontype = 'selectRecruitmentActive';
            return await this.fetch(actiontype, params);
        },
        // 疫情公告
        async newCrownNotice(params) {
            let actiontype = 'flightPrompting/getPrompting';
            return await this.fetch(actiontype, params);
        },
        // 疫情公告V2
        async newCrownNoticeV2(params) {
            let actiontype = 'flightPrompting/getPromptingV2';
            return await this.fetch(actiontype, params);
        },
        //推荐会员注册
        async takeFreshVip(params) {
            let actiontype = 'B2CLaUser_RefereeUserRegister';
            return await this.fetch(actiontype, params);
        },
        //获取会员推广人数
        async getFreshVipPopularizeRecord(params) {
            let actiontype = 'CommonPopularize_GetPopularizeRecordByUserID';
            return await this.fetch(actiontype,params);
        },
        //会员推广人信息
        async getRefereeInfoByCode(params) {
            let actiontype = 'CommonPopularize_GetRefereeInfoByCode';
            return await this.fetch(actiontype, params);
        },
        //注册成为推广人
        async innerRefereeRegist(params) {
            let actiontype = 'CommonPopularize_InnerRefereeRegist';
            return await this.fetch(actiontype,params);
        },
        //获取会员推广QrCode
        async getPopularizeCode(params) {
            let actiontype = 'CommonPopularize_GetPopularizeCode';
            return await this.fetch(actiontype,params);
        },
        // 秒杀首页展示  
        async getSecKillList(params) {
            let actiontype = 'FlashSaleService_getActivityFltLineInfo';
            return await this.fetch(actiontype, params, false, 30000);
        },
        // 秒杀查询接口 
        async getXCabinFlightSearch(params) {
            let actiontype = 'FlightService_XCabinFlightSearch';
            return await this.fetch(actiontype, params);
        },
        // 秒杀创单接口 
        async createXcabinOrder(params) {
            let actiontype = 'FlashSaleService_createXcabinOrder';
            return await this.fetch(actiontype, params, false, 20000);
        },
        // 秒杀订单详情接口  
        async getXcabinOrderDetail(params) {
            let actiontype = 'FlashSale/OrderDetail';
            return await this.fetch(actiontype, params);
        },
        // 判断是不是会员日接口 
        async isCheckVipDay(params) {
            let actiontype = 'FlashSale_GetConfigSwithch';
            return await this.fetch(actiontype, params);
        },
        // 春运营销活动H5-创建订单
        async createOrder(params) {
            let actiontype = 'createReceiptOrder';
            return await this.fetch(actiontype, params);
        },
        // 春运营销活动H5-获取支付链接
        async getLetterPayUrl(params) {
            let actiontype = 'getReceiptPayUrl';
            return await this.fetch(actiontype, params);
        },
        // 春运营销活动H5-获取订单列表
        async getAllorder(params) {
            let actiontype = 'ccsaleorder_getMyReceiptOrderList';
            return await this.fetch(actiontype, params);
        },
        // 春运营销活动H5-取消订单
        async orderCancel(params) {
            let actiontype = 'cancelReceiptOrder';
            return await this.fetch(actiontype, params);
        },
        // 春运营销活动H5-退单
        async orderRefund(params) {
            let actiontype = 'createRefundReceiptOrder';
            return await this.fetch(actiontype, params);
        },
        // 春运营销活动H5-删除订单
        async orderDelete(params) {
            let actiontype = 'ccsaleorder_deleteReceiptOrder';
            return await this.fetch(actiontype, params);
        },
        // 春运营销活动H5-删除订单
        async orderDelete(params) {
            let actiontype = 'ccsaleorder_deleteReceiptOrder';
            return await this.fetch(actiontype, params);
        },
        // 九宫格抽奖-页面信息（背景图、奖品）
        async ninePageGet(params) {
            let actiontype = 'getDrawLotterySource';

            return await this.fetch(actiontype, params,true);
        },
        // 九宫格抽奖-抽奖次数
        async ninePageDrawTimes(params) {
            let actiontype = 'getDrawTime';
            return await this.fetch(actiontype, params);
        },
        // 九宫格抽奖-抽奖
        async ninePageDraw(params) {
            let actiontype = 'drawLottery';
            return await this.fetch(actiontype, params,true);
        },
        // 九宫格抽奖-邮寄信息
        async ninePageAddress(params) {
            let actiontype = 'addMyAddress';
            return await this.fetch(actiontype, params);
        },
        // 九宫格抽奖-查看我的中奖
        async ninePageDrawMine(params) {
            let actiontype = 'getMyDrawRecord';
            return await this.fetch(actiontype, params);
        },
        // 短信链接-赔付申请-订单查询
        async getCompensationInformation(params) {
            let actiontype = 'PsgService_FlightCompensatePassengerGetDetailInfo';
            return await this.fetch(actiontype, params);
        },
        // 短信链接-赔付申请-订单提交
        async submitCompensationInformation(params) {
            let actiontype = 'PsgService_FlightCompensatePassengerSubmit';
            return await this.fetch(actiontype, params);
        },
    }


// WEBPACK FOOTER //
// ./src/interfaces/modules/activity.js